import React from 'react'

import { CheckboxInputProps } from './interface'

export function withCheckboxInput(Component: React.FC<CheckboxInputProps>) {
  function WithCheckboxInput(props: CheckboxInputProps) {
    return <Component {...props} />
  }

  return WithCheckboxInput
}
